import { render } from "./OceanNoiseRipple.vue?vue&type=template&id=b75adffa&scoped=true"
import script from "./OceanNoiseRipple.vue?vue&type=script&lang=js"
export * from "./OceanNoiseRipple.vue?vue&type=script&lang=js"

import "./OceanNoiseRipple.vue?vue&type=style&index=0&id=b75adffa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b75adffa"]])

export default __exports__